import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-sla-milestone-report-dw",
  templateUrl: "./sla-milestone-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlaMilestoneReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.SLA_MILESTONE_REPORT_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID];
}
